import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=93c6164c&scoped=true&lang=html&"
import script from "./changelog.vue?vue&type=script&lang=js&"
export * from "./changelog.vue?vue&type=script&lang=js&"
import style0 from "./changelog.vue?vue&type=style&index=0&id=93c6164c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c6164c",
  null
  
)

component.options.__file = "changelog.vue"
export default component.exports